const config = {
  default: {
    name: "Trackmydoc",
    domainName: "trackmydoc.com",
    intractName: "Trackmydoc",
    intractEmail: "trackmydoc@gmail.com",
    firmType: "cpa",
  },
   "client-tazimmigration.trackmydoc.com": {
    name: "Taz Immigration",
    domainName: "tazimmigration.com",
    logo: "/assets/logo/logo.png",
    favicon: "/assets/logo/favicon.ico",
    intractName: "Taz Immigration",
    intractEmail: "taz.immigration.inc@gmail.com",
    firmType: "immigration",
  },
};

const getSiteConfig = () => {
  const hostname = window.location.hostname;
  const matchedKey = Object.keys(config).find((key) => hostname.includes(key));
  return config[matchedKey] || config["default"];
};

const siteConfig = getSiteConfig();

export default siteConfig;
